module.exports = __webpack_public_path__ + "static/media/globe-asia.0785c4cc.svg";